<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="success"
        size="mini"
        style="margin-bottom: 5px"
        @click="getDate()"
        >刷新</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px; margin-bottom: 5px"
        @click="select()"
        >筛选</el-button
      >
      <!-- <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px;background: #6663FF;margin-bottom: 5px;"
        @click="getZhuList(1)"
        >归集USDT</el-button
      > -->
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="
          margin-left: 10px;
          background: #06cc00;
          border: 1px solid #06cc00;
          margin-bottom: 5px;
        "
        @click="zhuanTrx()"
        >转TRX</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="
          margin-left: 10px;
          background: #06cc00;
          border: 1px solid #06cc00;
          margin-bottom: 5px;
        "
        @click="getZhuList(2)"
        >归集TRX</el-button
      >
      <!-- <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px;background: #0C7DFF;border:1px solid #0C7DFF;margin-bottom: 5px;"
        @click="getDelegatedEnergy()"
        >代理能量</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px;background: #0C7DFF;border:1px solid #0C7DFF;margin-bottom: 5px;"
        @click="undelegateResource()"
        >回收能量</el-button
      > -->
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="
          margin-left: 10px;
          background: #ff7845;
          border: 1px solid #ff7845;
          margin-bottom: 5px;
        "
        @click="batchFreshUSDT()"
        :loading="loadingBatch"
        >一键刷新</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="
          margin-left: 10px;
          background: #ff7845;
          border: 1px solid #ff7845;
          margin-bottom: 5px;
        "
        @click="getZhuList(3)"
        >一键归U</el-button
      >
      <div class="guiJi">
        <div class="guiJi_title">归集进度：{{ ca1 || 0 }}/{{ ca2 || 0 }}</div>
        <el-button type="text" @click="getCollectList">详情</el-button>
        <el-button type="text" @click="collectListRemove">清空</el-button>
      </div>
    </div>
    <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px">用户</label>
        <el-input
          v-model="uid"
          placeholder="请输入uid"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <!-- <div class="item_warp">
        <label style="margin: 0 10px">账号</label>
        <el-input
          v-model="username"
          placeholder="请输入账号"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div> -->
      <div class="item_warp">
        <label style="margin: 0 10px">未归集金额 ></label>
        <el-input
          v-model="unCollectAmount"
          placeholder="请输入未归集金额"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">未归集Trx ></label>
        <el-input
          v-model="unCollectTrx"
          placeholder="请输入未归集Trx"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">账号钱包地址</label>
        <el-input
          v-model="address"
          placeholder="请输入账号钱包地址"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <!-- <div class="item_warp">
        <label style="margin: 0 10px">代理能量 ></label>
        <el-input
          v-model="delegatedEnergy"
          placeholder="请输入代理能量"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div> -->
      <div class="item_warp">
        <label style="margin: 0 10px">TRX余额</label>
        <el-select v-model="hasTrx" placeholder="请选择" clearable>
          <el-option label="不限" value=""></el-option>
          <el-option label="有TRX" value="true"></el-option>
          <el-option label="无TRX" value="false"></el-option>
        </el-select>
      </div>
      <!-- <div class="item_warp">
        <label style="margin: 0 10px">剩余代理能量</label>
        <el-select v-model="hasEnergy" placeholder="请选择" clearable>
          <el-option label="不限" value=""></el-option>
          <el-option label="有能量" value="true"></el-option>
          <el-option label="无能量" value="false"></el-option>
        </el-select>
      </div> -->
      <div class="item_warp">
        <label style="margin: 0 10px">已归集余额</label>
        <el-select v-model="isHadCollectAmount" placeholder="请选择" clearable>
          <el-option label="不限" value=""></el-option>
          <el-option label=">0" value="true"></el-option>
          <el-option label="<0" value="false"></el-option>
        </el-select>
      </div>
    </div>
    <div class="head_search">
      <div class="item_warp">
        <div style="color: red">
          未归集USDT：{{ totalRechargeCunt.unCollectUsdt || 0 }}
        </div>
      </div>
      <div class="item_warp" style="margin-left: 10px">
        <div style="color: red">
          未归集TRX：{{ totalRechargeCunt.unCollectTrx || 0 }}
        </div>
      </div>
      <!-- <div class="item_warp"> 
        <div style="color: red">未归集金额：{{ totalRechargeCunt.amount1 || 0 }}</div>
      </div>
      <div class="item_warp" style="margin-left: 10px;">
        <div style="color: red">总转入金额：{{ totalRechargeCunt.amount2 || 0 }}</div>
      </div>
      <div class="item_warp" style="margin-left: 10px;">
        <div style="color: red">已归集金额：{{ totalRechargeCunt.amount3 || 0 }}</div>
      </div> -->
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 1061px"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="uid" label="用户" width="100" />
      <el-table-column prop="tronAddress" label="账号钱包地址" width="150" />
      <el-table-column prop="address" label="未归集金额" width="100">
        <template slot-scope="scope">
          <div style="font-weight: 900; color: red">
            {{ scope.row.unCollectAmount }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="collectAmount" label="已归集余额" width="100" />
      <el-table-column prop="trx" label="trx余额" width="100" />
      <el-table-column prop="delegatedEnergy" label="代理能量" width="100" />
      <el-table-column prop="tronFreeNet" label="剩余带宽" width="100" />
      <el-table-column prop="createDate" label="创建时间" width="170" />
      <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.isSystem">-</div>
          <el-button
            v-else
            type="primary"
            class="edit-button"
            size="mini"
            @click="freshUSDT(scope.row)"
            >刷新</el-button
          >
        </template>
      </el-table-column>
      <!-- <el-table-column prop="vipLevel" label="VIP" width="100" />
      <el-table-column prop="amount" label="余额" width="100" />
      <el-table-column prop="totalRecharge" label="总充值" width="100" />
      <el-table-column prop="memo" label="总提现" width="100" /> -->
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />
    <!-- 归集主账号 -->
    <el-dialog
      :visible.sync="editPasswordShow"
      width="400px"
      :center="true"
      title="主账号选择"
      :close-on-click-modal="false"
    >
      <div>
        <div style="margin: 15px 0" class="radioGroup">
          <el-radio-group v-model="masterAccountId">
            <el-radio
              style="white-space: break-spaces"
              v-for="(item, index) in masterAccountList"
              :key="index"
              :label="item.id"
            >
              {{ item.address
              }}<span v-if="item.memo" style="margin-left: 10px"
                >({{ item.memo }})</span
              >
            </el-radio>
          </el-radio-group>
        </div>
        <div style="display: flex; justify-content: center" v-if="type == 1">
          <el-button type="primary" class="edit-button" @click="collect()"
            >确定</el-button
          >
        </div>
        <div style="display: flex; justify-content: center" v-if="type == 2">
          <el-button type="primary" class="edit-button" @click="collectTrx()"
            >确定</el-button
          >
        </div>
        <div style="display: flex; justify-content: center" v-if="type == 3">
          <el-button type="primary" class="edit-button" @click="oneCollect()"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="700px"
      title="详情"
      :close-on-click-modal="false"
    >
      <div>
        <!-- 表单 -->
        <el-table
          ref="gridTable"
          v-loading="loading"
          :data="collectList"
          tooltip-effect="dark"
          :stripe="true"
          :border="true"
          height="740px"
          style="width: 591px"
          size="mini"
        >
          <el-table-column prop="uid" label="用户" width="100" />
          <el-table-column prop="totalAmount" label="状态" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 0" style="color: #ababab">
                进行中
              </div>
              <div v-if="scope.row.status == 1" style="color: #06cc00">
                已完成
              </div>
              <div v-if="scope.row.status == 2" style="color: #ff0000">
                失败
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="totalTeamAmount"
            label="代理能量状态"
            width="130"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.delegatedStatus == 0">未代理</div>
              <div v-if="scope.row.delegatedStatus == 1">已代理</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="investTotalAmount"
            label="归集USDT状态"
            width="130"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.usdtStatus == 0">未归集</div>
              <div v-if="scope.row.usdtStatus == 1">已归集</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="serviceChargeTotal"
            label="回收能量状态"
            width="130"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.undelegateStatus == 0">未回收</div>
              <div v-if="scope.row.undelegateStatus == 1">已回收</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibleTrx"
      width="30%"
    >
      <span>是否转TRX?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTrx = false">取 消</el-button>
        <el-button type="primary" @click="zhuanBnb">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination, VueUeditorWrap },
  data() {
    return {
      tableData: [], // 展示的表单信息
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      loading: false, // 表格加
      uid: "",
      username: "",
      unCollectAmount: "",
      unCollectTrx: "",
      address: "",
      delegatedEnergy: "",
      hasTrx: "",
      hasEnergy: "",
      isHadCollectAmount: "",
      totalRechargeCunt: {},
      multipleSelection: [],
      editPasswordShow: false,
      dialogVisibleTrx: false,
      dialogVisible: false,
      masterAccountId: "",
      masterAccountList: [],
      collectList: [],
      type: 1,
      ca1: 0,
      ca2: 0,
      time: null,
      loadingBatch: false,
    };
  },
  mounted() {
    this.getDate();
    this.collectView();
    this.time = setInterval(() => {
      this.collectView();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.time);
  },
  methods: {
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
    },
    getDate() {
      this.getList();
    },
    // 主体
    getZhuList(type) {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.type = type;
      this.$api.capital
        .masterAccountsT()
        .then((res) => {
          if (res.length > 0) {
            this.editPasswordShow = true;
            this.masterAccountList = res;
          } else {
            this.$message.info("暂无主体");
          }
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 一键刷新
    batchFreshUSDT(type) {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      if (this.loadingBatch) return;
      this.loadingBatch = true;
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.capital
        .batchFreshUSDT(params)
        .then((res) => {
          this.$message.success(res);
          this.loadingBatch = false;
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
          this.loadingBatch = false;
        })
        .finally(() => {
          this.loadingBatch = false;
        });
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        uid: this.uid,
        username: this.username,
        unCollectAmount: this.unCollectAmount,
        unCollectTrx: this.unCollectTrx,
        address: this.address,
        delegatedEnergy: this.delegatedEnergy,
        hasTrx: this.hasTrx,
        hasEnergy: this.hasEnergy,
        isHadCollectAmount: this.isHadCollectAmount,
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.capital
        .memberCollectionList(params)
        .then((res) => {
          this.tableData = res.page.records;
          this.total = res.page.total;
          this.totalRechargeCunt = {
            unCollectUsdt: res.unCollectUsdt,
            unCollectTrx: res.unCollectTrx,
          };
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 刷新
    freshUSDT(row) {
      this.$api.capital
        .freshUSDT({ id: row.id })
        .then((res) => {
          this.$message.success(res);
          this.getDate();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 代理能量
    getDelegatedEnergy() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否代理能量?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          var params = {
            ids: ids.toString(),
          };
          this.$api.capital
            .delegatedEnergy(params)
            .then((res) => {
              this.$message.success(res);
              this.getList();
              this.editPasswordShow = false;
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            });
        })
        .catch(() => {});
    },
    // 回收能量
    undelegateResource() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否回收能量?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var ids = [];
          this.multipleSelection.forEach((item) => {
            ids.push(item.id);
          });
          var params = {
            ids: ids.toString(),
          };
          this.$api.capital
            .undelegateResource(params)
            .then((res) => {
              this.$message.success(res);
              this.getList();
              this.editPasswordShow = false;
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            });
        })
        .catch(() => {});
    },
    // 转TRX
    zhuanTrx() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.dialogVisibleTrx = true;
      // this.$confirm("是否转TRX?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      //     var ids = [];
      //   this.multipleSelection.forEach((item) => {
      //     ids.push(item.id);
      //   });
      //   var params = {
      //     ids: ids.toString()
      //   };
      //   this.$api.capital
      //     .zhuanTrx(params)
      //     .then((res) => {
      //       this.$message.success(res);
      //       this.getList();
      //       this.editPasswordShow = false
      //     })
      //     .catch((err) => {
      //       this.$message.error(err || "服务器错误，请稍后重试");
      //     })
      //   })
      //   .catch(() => {

      //   });
    },
    zhuanBnb() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.capital
        .zhuanTrx(params)
        .then((res) => {
          this.$message.success(res);
          this.getList();
          this.dialogVisibleTrx = false;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
    },
    // 归集USDT
    collect() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
        masterAccountId: this.masterAccountId,
      };
      this.$api.capital
        .collect(params)
        .then((res) => {
          this.$message.success(res);
          this.getList();
          this.editPasswordShow = false;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        });
    },
    // 归集TRX
    collectTrx() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
        masterAccountId: this.masterAccountId,
      };
      this.$api.capital
        .collectTrx(params)
        .then((res) => {
          this.$message.success(res);
          this.getList();
          this.editPasswordShow = false;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        });
    },
    // 一键归U
    oneCollect() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
        masterAccountId: this.masterAccountId,
      };
      this.$api.capital
        .oneCollect(params)
        .then((res) => {
          this.$message.success(res);
          this.getList();
          this.editPasswordShow = false;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        });
    },
    // 清空归集进度
    collectListRemove() {
      this.$confirm("是否清空归集进度?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.capital
            .collectListRemove()
            .then((res) => {
              this.$message.success(res);
              this.getList();
              this.editPasswordShow = false;
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            });
        })
        .catch(() => {});
    },
    // 归集进度
    collectView() {
      this.$api.capital
        .collectView()
        .then((res) => {
          this.ca1 = res.ca1;
          this.ca2 = res.ca2;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        });
    },
    getCollectList() {
      this.dialogVisible = true;
      this.$api.capital
        .collectList()
        .then((res) => {
          this.collectList = res;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.role_warp {
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
.guiJi {
  display: flex;
  align-items: center;
  margin-left: 10px;
}
.guiJi_title {
  color: #6663ff;
  margin-right: 10px;
}
::v-deep .el-radio {
  margin-bottom: 10px !important;
}
</style>
